export interface Cookie {
    name: string;
    value: string;
    path: string;
    expires: Date;
    sameSite: string;
    secure: boolean;
}

export function readCookie(name: string): string {
    const nameEquals = name + "=";
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].replace(/^\s+/, "");
        if (cookie.indexOf(nameEquals) === 0) {
            return cookie.substring(nameEquals.length);
        }
    }
    return null;
}

export function setCookie(cookie: Cookie): void {
    document.cookie = `${cookie.name}=${cookie.value};expires=${cookie.expires.toUTCString()};path=${cookie.path};secure=${cookie.secure};samesite=${cookie.sameSite}`;
}


// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Utils/Cookies.ts